import { useEffect } from 'react';
import {baseUrl} from "../../constants/appUrls";

const useFavicon = (iconUrl) => {
  useEffect(() => {
    const setFavicon = (url) => {

      const links = document.querySelectorAll("link[rel*='icon']");
      links.forEach(link => link.parentNode.removeChild(link));
      // Создаем новый
      const link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;

      document.getElementsByTagName('head')[0].appendChild(link);

      // Для Safari на iOS
      const appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      appleTouchIcon.href = url;
      document.getElementsByTagName('head')[0].appendChild(appleTouchIcon);
    };

    if (iconUrl) {
      setFavicon(`${baseUrl}files/logo/${iconUrl}/favicon.ico`);
    }
  }, [iconUrl]);
};

export default useFavicon;